import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://0b8acd08ded0e7ea5569513e5123ff7c@o62445.ingest.us.sentry.io/4508666603110400",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});